import { GeneralCatalogItem } from 'data-layer-cr/dist/models';
import CatalogItem from 'src/models/helperTypes/CatalogItem';

const selectedBrandFound = (
  brandsList: CatalogItem[],
  value: string,
): number => {
  const foundBrand = brandsList.find((model) => model.Value === value);
  if (foundBrand?.Object) {
    const brandId = foundBrand.Object as GeneralCatalogItem;
    return brandId.id;
  }
  return -1;
};

export default selectedBrandFound;
